// Presets de servidor dos provedores de e-mail mais usados pelos nossos
// clientes. Um lugar so: a criacao da caixa e a tela de configuracao (IMAP e
// SMTP) leem daqui.
//
// Regra de porta: sempre que o provedor recomendar 465/SSL, mantemos
// 587/STARTTLS — a porta 465 e bloqueada na saida do nosso servidor (anti-spam
// da Hetzner).
//
// `addressPattern` e pra provedor cujo servidor depende do dominio do cliente
// (mail.empresa.com.br); `{dominio}` e trocado pelo que a pessoa digitar.
export const EMAIL_PROVIDERS = [
  {
    key: 'hostverge',
    label: 'Hostverge / Stackmail',
    imap: { address: 'imap.stackmail.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.stackmail.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'hostgator',
    label: 'Hostgator',
    imap: {
      address: '',
      port: 993,
      ssl: true,
      addressPattern: 'mail.{dominio}',
    },
    smtp: {
      address: '',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
      addressPattern: 'mail.{dominio}',
    },
  },
  {
    key: 'locaweb',
    label: 'Locaweb',
    imap: { address: 'imap.locaweb.com.br', port: 993, ssl: true },
    smtp: {
      address: 'smtp.locaweb.com.br',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'gmail',
    label: 'Gmail / Google Workspace',
    imap: { address: 'imap.gmail.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.gmail.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
    note: 'Gmail/Google Workspace exige "senha de aplicativo" (não a senha normal). Crie em myaccount.google.com → Segurança → Senhas de app.',
  },
  {
    key: 'outlook',
    label: 'Outlook / Microsoft 365',
    imap: { address: 'outlook.office365.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.office365.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'titan',
    label: 'Titan (Hostinger)',
    imap: { address: 'imap.titan.email', port: 993, ssl: true },
    smtp: {
      address: 'smtp.titan.email',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'uolhost',
    label: 'UOL Host',
    imap: { address: 'imap.uhserver.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.uhserver.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'kinghost',
    label: 'KingHost',
    imap: {
      address: '',
      port: 993,
      ssl: true,
      addressPattern: 'imap.{dominio}',
    },
    smtp: {
      address: '',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
      addressPattern: 'smtp.{dominio}',
    },
  },
  {
    key: 'zoho',
    label: 'Zoho Mail',
    imap: { address: 'imap.zoho.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.zoho.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'terra',
    label: 'Terra',
    imap: { address: 'imap.terra.com.br', port: 993, ssl: true },
    smtp: {
      address: 'smtp.terra.com.br',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
  },
  {
    key: 'yahoo',
    label: 'Yahoo Mail',
    imap: { address: 'imap.mail.yahoo.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.mail.yahoo.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
    note: 'O Yahoo exige "senha de aplicativo" (não a senha normal). Crie em login.yahoo.com → Segurança da conta → Gerar senha de app.',
  },
  {
    key: 'icloud',
    label: 'iCloud Mail',
    imap: { address: 'imap.mail.me.com', port: 993, ssl: true },
    smtp: {
      address: 'smtp.mail.me.com',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
    note: 'O iCloud exige "senha de aplicativo" (não a senha do Apple ID). Crie em account.apple.com → Segurança → Senhas de app.',
  },
  {
    key: 'cpanel',
    label: 'cPanel / servidor próprio (mail.seudominio)',
    imap: {
      address: '',
      port: 993,
      ssl: true,
      addressPattern: 'mail.{dominio}',
    },
    smtp: {
      address: '',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
      addressPattern: 'mail.{dominio}',
    },
    note: 'Vale pra maioria das hospedagens com cPanel ou Plesk. Se não conectar, confirme o endereço do servidor com o seu provedor.',
  },
  {
    key: 'manual',
    label: 'Outro — preencher na mão',
    manual: true,
    imap: { address: '', port: 993, ssl: true },
    smtp: {
      address: '',
      port: 587,
      encryption: 'starttls',
      verifyMode: 'none',
      auth: 'login',
    },
    note: 'Preencha servidor e porta com o que o seu provedor informa. O padrão costuma ser: entrada (IMAP) 993 com SSL, saída (SMTP) 587 com STARTTLS.',
  },
];

export const findProvider = key => EMAIL_PROVIDERS.find(p => p.key === key);

// Provedor cujo servidor depende do dominio do cliente.
export const providerNeedsDomain = key => {
  const preset = findProvider(key);
  return !!(preset?.imap?.addressPattern || preset?.smtp?.addressPattern);
};

// Devolve { imap, smtp } com o {dominio} ja trocado.
export const resolveProvider = (key, domain = '') => {
  const preset = findProvider(key);
  if (!preset) return null;

  const imap = { ...preset.imap };
  const smtp = { ...preset.smtp };
  if (preset.imap.addressPattern && domain) {
    imap.address = preset.imap.addressPattern.replace('{dominio}', domain);
  }
  if (preset.smtp.addressPattern && domain) {
    smtp.address = preset.smtp.addressPattern.replace('{dominio}', domain);
  }
  return { imap, smtp, note: preset.note || '', manual: !!preset.manual };
};

// O dominio de um e-mail, pra pre-preencher o campo dos provedores por padrao.
export const domainFromEmail = value => (value || '').split('@')[1] || '';
